import { Dispatch, SetStateAction } from 'react'

import UserDetails from '../../routes/contacts/user-details-drawer/user-details'
import useIsMobile from '../../utils/hooks/useIsMobile'
import FullScreenModal from '../full-screen-modal'

interface IProps {
  isOpen: boolean
  onClose: () => void
  user: IUserType
  selectedFolderId: number | undefined
  setOpen?: Dispatch<SetStateAction<boolean>>
}

const ContactDetailsModal = (props: IProps) => {
  const { isOpen, onClose, user, selectedFolderId, setOpen } = props
  const isMobile = useIsMobile()

  return (
    <FullScreenModal
      title="Contact Details"
      open={isOpen}
      onClose={onClose}
      showCloseIcon={true}
      confirmLabel={!isMobile ? 'Close' : undefined}
      onConfirm={!isMobile ? onClose : undefined}
      maxWidth="sm"
    >
      <UserDetails user={user} selectedFolderId={selectedFolderId} setOpen={setOpen} />
    </FullScreenModal>
  )
}

export default ContactDetailsModal
